import { createRouter,createWebHashHistory } from 'vue-router'
//登录注册
import login from '@/components/login/login.vue'
import register from '@/components/register/register.vue'
import forgetPassword from '@/components/forgetPassword/forgetPassword.vue'
import home from '@/components/home/home.vue'

//检查管理
import inspectionManagement from '@/components/inspectionManagement/inspectionManagement.vue'
import physicalAssessment from '@/components/physicalAssessment/physicalAssessment.vue'

//报告管理
import historyList from '@/components/historyList/historyList.vue'
import reportHos from '@/components/historyList/reportHos.vue'
import reportOverview from '@/components/historyList/reportOverview.vue'
import viewReport from '@/components/historyList/viewReport.vue'
import viewReportShort from '@/components/historyList/viewReportShort.vue'
import viewReportPdf from '@/components/historyList/viewReportPdf.vue'

//客户管理
import userManagement from '@/components/userManagement/userManagement.vue'
import insManagement from '@/components/userManagement/insManagement.vue'
import accountList from '@/components/userManagement/accountList.vue'
/* import userManagementDetail from '@/components/userManagement/userManagementDetail.vue'
import insManagementDetail from '@/components/userManagement/insManagementDetail.vue'
import addInsManagement from '@/components/userManagement/addInsManagement.vue'
import editInsManagement from '@/components/userManagement/editInsManagement.vue'
*/
//基础设置
import tongueInterpretation from '@/components/basicSetting/tongueInterpretation.vue'
import reportResult from '@/components/basicSetting/reportResult.vue'
import ruleSetting from '@/components/basicSetting/ruleSetting.vue'
import healthPlan from '@/components/basicSetting/healthPlan.vue'
import versionManagement from '@/components/basicSetting/versionManagement.vue'

  //知识库管理
import dietRecommend from '@/components/knowledgeManagement/dietRecommend.vue'
import constituteManagement from '@/components/knowledgeManagement/constituteManagement.vue'
import optionManagement from '@/components/knowledgeManagement/optionManagement.vue'
import healthAssessment from '@/components/knowledgeManagement/healthAssessment.vue'
import physiothMainten from '@/components/knowledgeManagement/physiothMainten.vue'
import sportsHealth from '@/components/knowledgeManagement/sportsHealth.vue'
 import lifeGuidance from '@/components/knowledgeManagement/lifeGuidance.vue'
 import drugManagement from '@/components/knowledgeManagement/drugManagement.vue'
import pictureManagement from '@/components/knowledgeManagement/picManagement.vue'
import videoManagement from '@/components/knowledgeManagement/videoManagement.vue'

//内容管理
import homeManage from '@/components/contentManagement/homeManage.vue'
import aboutManage from '@/components/contentManagement/aboutManage.vue'
import qualificationManage from '@/components/contentManagement/qualificationManage.vue'

//商城管理
import commissionConfig from '@/components/mallManagement/commissionConfig.vue'
import mallDashboard from '@/components/mallManagement/dashboard.vue'
import productManage from '@/components/mallManagement/productManage.vue'
import memberManage from '@/components/mallManagement/memberManage.vue'
import adminInvite from '@/components/mallManagement/adminInvite.vue'
import orderManage from '@/components/mallManagement/orderManage.vue'
import withdrawalManage from '@/components/mallManagement/withdrawalManage.vue'
import refundManage from '@/components/mallManagement/refundManage.vue'
import rechargeManage from '@/components/mallManagement/rechargeManage.vue'
import platformAccount from '@/components/mallManagement/platformAccount.vue'
import cityAgentApplyManage from '@/components/mallManagement/cityAgentApplyManage.vue'

//个人中心
import personalCenter from '@/components/personalCenter/personalCenter.vue'
import modifyPassword from '@/components/personalCenter/modifyPassword.vue'

import update from '@/components/update/update.vue'

const routes  = [
 //登录
 {
 	path: '/login/login',
 	name: 'login',
 	component: login,
 	meta: {
 		requireAuth: false, //是否要登录
 	},
 },
 //注册
		{
			path: '/register/register',
			name: 'register',
			component: register,
			meta: {
				requireAuth: false, //是否要登录
			},
		},
		//忘记密码
		{
			path: '/forgetPassword/forgetPassword',
			name: 'forgetPassword',
			component: forgetPassword,
			meta: {
				requireAuth: false, //是否要登录
			},
		},
		//检查管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/inspectionManagement/inspectionManagement' ,
			children: [{
				path: '/inspectionManagement/inspectionManagement',
				name: 'inspectionManagement',
				component: inspectionManagement,
				menuName: '检查管理',
				
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		//检查管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/physicalAssessment/physicalAssessment' ,
			children: [{
				path: '/physicalAssessment/physicalAssessment',
				name: 'physicalAssessment',
				component: physicalAssessment,
				menuName: '体质评估',
				
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		//历史列表
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/historyList/historyList' ,
			children: [{
				path: '/historyList/historyList',
				name: 'historyList',
				component: historyList,
				menuName: '历史列表',
				meta: {
					keepAlive:true,
				},
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/historyList/reportHos' ,
			children: [{
				path: '/historyList/reportHos',
				name: 'reportHos',
				component: reportHos,
				menuName: '历史列表',
				meta: {
					keepAlive:true,
				},
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		//历史列表
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/historyList/reportOverview' ,
			children: [{
				path: '/historyList/reportOverview',
				name: 'reportOverview',
				component: reportOverview,
				menuName: '平台查看',
				meta: {
					keepAlive:true,
				},
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		
		//历史列表
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/historyList/viewReport' ,
			children: [{
				path: '/historyList/viewReport',
				name: 'viewReport',
				component: viewReport,
				menuName: '查看报告',
				meta: {
					//keepAlive:true,
				},
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		{
			path: '/historyList/viewReportPdf',
			name: 'viewReportPdf', // 根据type区分不同模块（顶部导航）
			component: viewReportPdf,
			meta: {
				requireAuth: false, //是否要登录
			},
		},
		{
			path: '/historyList/viewReportShort',
			name: 'viewReportShort', // 根据type区分不同模块（顶部导航）
			component: viewReportShort,
			meta: {
				requireAuth: false, //是否要登录
			},
		},
		
		/*--------------------------------客户管理-----------------*/
		//用户管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/userManagement/userManagement' ,
			children: [{
				path: '/userManagement/userManagement',
				name: 'userManagement',
				component: userManagement,
				menuName: '用户管理',
				meta: {
					keepAlive:true,
				},
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/userManagement/insManagement' ,
			children: [{
				path: '/userManagement/insManagement',
				name: 'insManagement',
				component: insManagement,
				menuName: '机构管理',
				meta: {
					keepAlive:true,
				},
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},

		//账号管理（医生 / 机构管理员）
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect: '/userManagement/accountList',
			children: [{
				path: '/userManagement/accountList',
				name: 'accountList',
				component: accountList,
				menuName: '账号管理',
				meta: {
					keepAlive: true,
				},
			}, ],
			meta: {
				requireAuth: true,
			},
		},

		/*--------------------------------基础设置-----------------*/
		   
		//舌面释义
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/basicSetting/tongueInterpretation' ,
			children: [{
				path: '/basicSetting/tongueInterpretation',
				name: 'tongueInterpretation',
				component: tongueInterpretation,
				menuName: '舌面释义',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		
		//报告结果
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/basicSetting/reportResult' ,
			children: [{
				path: '/basicSetting/reportResult',
				name: 'reportResult',
				component: reportResult,
				menuName: '报告结果',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		 //规则设置
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/basicSetting/ruleSetting' ,
			children: [{
				path: '/basicSetting/ruleSetting',
				name: 'ruleSetting',
				component: ruleSetting,
				menuName: '规则设置',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		//规则设置
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/basicSetting/healthPlan' ,
			children: [{
				path: '/basicSetting/healthPlan',
				name: 'healthPlan',
				component: healthPlan,
				menuName: '养生方案',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		//版本管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/basicSetting/versionManagement' ,
			children: [{
				path: '/basicSetting/versionManagement',
				name: 'versionManagement',
				component: versionManagement,
				menuName: '版本管理',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		/*--------------------------------知识库管理-----------------*/
		//饮食推荐
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/dietRecommend' ,
			children: [{
				path: '/knowledgeManagement/dietRecommend',
				name: 'dietRecommend',
				component: dietRecommend,
				menuName: '饮食推荐',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		 
		//体质管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/constituteManagement' ,
			children: [{
				path: '/knowledgeManagement/constituteManagement',
				name: 'constituteManagement',
				component: constituteManagement,
				menuName: '体质管理',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		  //选项管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/optionManagement' ,
			children: [{
				path: '/knowledgeManagement/optionManagement',
				name: 'optionManagement',
				component: optionManagement,
				menuName: '选项管理',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		//健康评估
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/healthAssessment' ,
			children: [{
				path: '/knowledgeManagement/healthAssessment',
				name: 'healthAssessment',
				component: healthAssessment,
				menuName: '健康评估',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		 //理疗维护
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/physiothMainten' ,
			children: [{
				path: '/knowledgeManagement/physiothMainten',
				name: 'physiothMainten',
				component: physiothMainten,
				menuName: '理疗维护',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		  //运动健康
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/sportsHealth' ,
			children: [{
				path: '/knowledgeManagement/sportsHealth',
				name: 'sportsHealth',
				component: sportsHealth,
				menuName: '运动健康',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		 //生活指导
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/lifeGuidance' ,
			children: [{
				path: '/knowledgeManagement/lifeGuidance',
				name: 'lifeGuidance',
				component: lifeGuidance,
				menuName: '生活指导',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		 //药食管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/drugManagement' ,
			children: [{
				path: '/knowledgeManagement/drugManagement',
				name: 'drugManagement',
				component: drugManagement,
				menuName: '药食管理',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		
		 //图片管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/picManagement' ,
			children: [{
				path: '/knowledgeManagement/picManagement',
				name: 'picManagement',
				component: pictureManagement,
				menuName: '图片管理',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		 //视频管理
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/knowledgeManagement/videoManagement' ,
			children: [{
				path: '/knowledgeManagement/videoManagement',
				name: 'videoManagement',
				component: videoManagement,
				menuName: '视频管理',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		
		/*--------------------------------内容管理-----------------*/
		//首页管理
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/contentManagement/homeManage' ,
			children: [{
				path: '/contentManagement/homeManage',
				name: 'homeManage',
				component: homeManage,
				menuName: '首页管理',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//关于我们
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/contentManagement/aboutManage' ,
			children: [{
				path: '/contentManagement/aboutManage',
				name: 'aboutManage',
				component: aboutManage,
				menuName: '关于我们',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//产品资质
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/contentManagement/qualificationManage' ,
			children: [{
				path: '/contentManagement/qualificationManage',
				name: 'qualificationManage',
				component: qualificationManage,
				menuName: '产品资质',
			}, ],
			meta: {
				requireAuth: true,
			},
		},

		/*--------------------------------商城管理-----------------*/
		//统计看板
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/dashboard' ,
			children: [{
				path: '/mallManagement/dashboard',
				name: 'mallDashboard',
				component: mallDashboard,
				menuName: '统计看板',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//商品管理
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/productManage' ,
			children: [{
				path: '/mallManagement/productManage',
				name: 'productManage',
				component: productManage,
				menuName: '商品管理',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//会员管理
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/memberManage' ,
			children: [{
				path: '/mallManagement/memberManage',
				name: 'memberManage',
				component: memberManage,
				menuName: '会员管理',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//代理邀请
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/adminInvite' ,
			children: [{
				path: '/mallManagement/adminInvite',
				name: 'adminInvite',
				component: adminInvite,
				menuName: '代理邀请',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//订单管理
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/orderManage' ,
			children: [{
				path: '/mallManagement/orderManage',
				name: 'orderManage',
				component: orderManage,
				menuName: '订单管理',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//提现审批
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/withdrawalManage' ,
			children: [{
				path: '/mallManagement/withdrawalManage',
				name: 'withdrawalManage',
				component: withdrawalManage,
				menuName: '提现审批',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//退款管理
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/refundManage' ,
			children: [{
				path: '/mallManagement/refundManage',
				name: 'refundManage',
				component: refundManage,
				menuName: '退款管理',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//佣金配置
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/commissionConfig' ,
			children: [{
				path: '/mallManagement/commissionConfig',
				name: 'commissionConfig',
				component: commissionConfig,
				menuName: '佣金配置',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//会员充值
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/rechargeManage' ,
			children: [{
				path: '/mallManagement/rechargeManage',
				name: 'rechargeManage',
				component: rechargeManage,
				menuName: '会员充值',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//平台账户
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/platformAccount' ,
			children: [{
				path: '/mallManagement/platformAccount',
				name: 'platformAccount',
				component: platformAccount,
				menuName: '平台账户',
			}, ],
			meta: {
				requireAuth: true,
			},
		},
		//城代审批
		{
			path: '/home/home',
			type: 'home',
			component: home,
			redirect:'/mallManagement/cityAgentApplyManage' ,
			children: [{
				path: '/mallManagement/cityAgentApplyManage',
				name: 'cityAgentApplyManage',
				component: cityAgentApplyManage,
				menuName: '城代审批',
			}, ],
			meta: {
				requireAuth: true,
			},
		},

		/*--------------------------------个人中心-----------------*/
		
		
		//个人中心
		{
			path: '/home/home',
			type: 'home', // 根据type区分不同模块（顶部导航）
			component: home,
			redirect:'/personalCenter/personalCenter' ,
			children: [{
				path: '/personalCenter/personalCenter',
				name: 'personalCenter',
				component: personalCenter,
				menuName: '个人中心',
			}, ],
			meta: {
				requireAuth: true, //是否要登录
			},
		},
		
		
		 
		  //修改密码
		  {
		  	path: '/home/home',
		  	type: 'home', // 根据type区分不同模块（顶部导航）
		  	component: home,
		  	redirect:'/personalCenter/regimen' ,
		  	children: [{
		  		path: '/personalCenter/modifyPassword',
		  		name: 'modifyPassword',
		  		component: modifyPassword,
		  		menuName: '修改密码',
		  	}, ],
		  	meta: {
		  		requireAuth: true, //是否要登录
		  	},
		  },
		//更新
		{
			path: '/update/update',
			name: 'update',
			component: update,
			meta: {
				requireAuth: false, //是否要登录
			},
		},
 //路由重定向
 {
 	path: '/',
 	redirect: {
 		path: '/login/login'
 	}
 }, 
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
	routes
})
 
export default router
